var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",class:[
    // Base class
    'v-text',

    // Font-size classes
    ("v-text--size-" + _vm.fontSize),
    !!_vm.fontMdSize && ("v-text--size-md-" + _vm.fontMdSize),
    !!_vm.fontLgSize && ("v-text--size-lg-" + _vm.fontLgSize),

    // Font weight and italic
    _vm.bold && 'font-weight-bold',
    _vm.italic && 'font-italic' ]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }